import React from 'react'
import axios from 'axios'

import Cabecalho from './Form/Cabecalho'

export default class ProcessoCapa extends React.Component {
    constructor(props) {
        super(props)
        this.state = {}
    }

    componentDidMount() {
        const id = this.props.match.params.id
        const url = `/api/ficha/processo/${id}`
        axios(url)
            .then(resp => {
                this.setState({ list: resp.data })
            })
            .catch(error => {
                alert(error.response.data)
            }
            )
    }

    render() {
        console.log(this.state.list)
        if (this.state.list) {
            let ano = this.state.list.data.slice(0, 4)
            let mes = this.state.list.data.slice(5, 7)
            let dia = this.state.list.data.slice(8, 10)
            let data = dia + "/" + mes + "/" + ano
            return (
                <React.Fragment>
                    <div className="container">
                        <Cabecalho valor={this.state.list} />
                        <div className="form-group row mt-3 text-left">
                            <label className="col-3">Processo:</label>
                            <div className="col-9 mb-3">
                                <input type="text" className="form-control"
                                    value={this.state.list.numero} />
                            </div>
                        </div>
                        <div className="form-group row mt-3 text-left">
                            <label className="col-3 col-md-3">Data:</label>
                            <div className="col-9 col-md-2 mb-3">
                                <input type="text" className="form-control"
                                    value={data} />
                            </div>
                        </div>
                        <div className="mt-5 font-weight-bold text-left">
                            1 - DADOS DO ESTABELECIMENTO:
                        </div>
                        <div className="form-group row mt-3 text-left">
                            <label className="col-4 col-md-2">Estabelecimento:</label>
                            <div className="col-8 col-md-4 mb-3">
                                <input type="text" className="form-control"
                                    value={this.state.list.estabelecimento} />
                            </div>
                            <label className="col-3 col-md-2">Nome Fantasia:</label>
                            <div className="col-9 col-md-4 mb-3">
                                <input type="text" className="form-control"
                                    value={this.state.list.fantasia} />
                            </div>
                            <label className="col-3 col-md-2">Registro:</label>
                            <div className="col-9 col-md-4 mb-3">
                                <input type="text" className="form-control"
                                    value={this.state.list.registro} />
                            </div>
                            <div className="col-12 col-md-6"></div>
                            <label className="col-3 col-md-2">Endereço:</label>
                            <div className="col-9 col-md-4 mb-3">
                                <input type="text" className="form-control"
                                    value={this.state.list.endereco} />
                            </div>
                            <label className="col-3 col-md-2">UF:</label>
                            <div className="col-9 col-md-4 mb-3">
                                <input type="text" className="form-control"
                                    value={this.state.list.uf} />
                            </div>
                            <label className="col-3 col-md-2">Município:</label>
                            <div className="col-9 col-md-2 mb-3">
                                <input type="text" className="form-control"
                                    value={this.state.list.municipio} />
                            </div>
                            <label className="col-3 col-md-2">CEP:</label>
                            <div className="col-9 col-md-2 mb-3">
                                <input type="text" className="form-control"
                                    value={this.state.list.cep} />
                            </div>
                            <label className="col-3 col-md-2">Telefone:</label>
                            <div className="col-9 col-md-2 mb-3">
                                <input type="text" className="form-control"
                                    value={this.state.list.telefone} />
                            </div>
                            <label className="col-4 col-md-2">Situação:</label>
                            <div className="col-8 col-md-4 mb-3">
                                <input type="text" className="form-control"
                                    value={this.state.list.setor} />
                            </div>
                            <label className="col-4 col-md-2">Tipo:</label>
                            <div className="col-8 col-md-4 mb-3">
                                <input type="text" className="form-control"
                                    value={this.state.list.tipo} />
                            </div>
                            <label className="col-12">Observações:</label>
                            <div className="form-control textarea text-left mb-5">{this.state.list.obs}</div>
                        </div>
                    </div>
                </React.Fragment>
            )
        } else {
            return <div></div>
        }
    }
}